import React from 'react'

function EmptyLayout({ children }) {
	return <>{children}</>
}
export default EmptyLayout
